import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = { class: "selected-set-name" }
const _hoisted_3 = {
  class: "selected-sets multiple",
  key: "multiple"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  class: "selected-sets placeholder",
  key: "placeholder"
}
const _hoisted_6 = { class: "options" }
const _hoisted_7 = ["onPointerup", "onPointerdown", "onPointerout"]
const _hoisted_8 = { class: "set-option" }
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = { class: "set-option-name" }

import { SetCode } from "@/Types";
import SetsInfos from "../../../src/SetInfos";
import { ref, onMounted, onUnmounted } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SetSelect',
  props: {
    modelValue: {},
    options: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const expanded = ref(false);
const ctrlPressed = ref(false);
const longPressTimeout = ref(null as ReturnType<typeof setTimeout> | null);
const longPressingSet = ref(null as SetCode | null);

const clearLongPress = () => {
	if (longPressTimeout.value) clearTimeout(longPressTimeout.value);
	longPressingSet.value = null;
};

const emit = __emit;

const add = (c: SetCode) => {
	if (!props.modelValue.includes(c)) emit("update:modelValue", [...props.modelValue, c]);
	else
		emit(
			"update:modelValue",
			props.modelValue.filter((v) => v !== c)
		);
};
const set = (c: SetCode) => emit("update:modelValue", [c]);
const toggle = () => (expanded.value = !expanded.value);
const close = () => (expanded.value = false);
const checkctrl = (e: KeyboardEvent) => (ctrlPressed.value = e.ctrlKey);

const pointerdown = (e: PointerEvent, c: SetCode) => {
	clearLongPress();
	longPressTimeout.value = setTimeout(() => {
		add(c);
		clearLongPress();
	}, 500);
	longPressingSet.value = c;
	e.preventDefault();
	e.stopPropagation();
};
const pointerup = (c: SetCode) => {
	if (c === longPressingSet.value) set(c);
	clearLongPress();
};
const ctrlpointerup = (c: SetCode) => {
	if (c === longPressingSet.value) add(c);
	clearLongPress();
};
const pointerout = (c: SetCode) => {
	if (c === longPressingSet.value) clearLongPress();
};

onMounted(() => {
	document.addEventListener("keydown", checkctrl);
	document.addEventListener("keyup", checkctrl);
	document.addEventListener("pointerdown", close);
});

onUnmounted(() => {
	document.removeEventListener("keydown", checkctrl);
	document.removeEventListener("keyup", checkctrl);
	document.removeEventListener("pointerdown", close);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["set-select", { expanded: expanded.value }]),
    onPointerdown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", {
      class: "select",
      onClick: _withModifiers(toggle, ["stop"])
    }, [
      _renderSlot(_ctx.$slots, "selection", { values: __props.modelValue }, () => [
        (__props.modelValue.length == 1)
          ? (_openBlock(), _createElementBlock("span", {
              class: "selected-sets",
              key: __props.modelValue[0]
            }, [
              _createElementVNode("img", {
                class: "set-icon",
                style: {"padding-left":"4px","padding-right":"4px"},
                src: _unref(SetsInfos)[__props.modelValue[0]].icon,
                alt: _unref(SetsInfos)[__props.modelValue[0]].code
              }, null, 8 /* PROPS */, _hoisted_1),
              _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(SetsInfos)[__props.modelValue[0]].fullName), 1 /* TEXT */)
            ]))
          : (__props.modelValue.length > 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                _createElementVNode("span", null, "(" + _toDisplayString(__props.modelValue.length) + ")", 1 /* TEXT */),
                _createVNode(_TransitionGroup, { name: "fade" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.modelValue, (v) => {
                      return (_openBlock(), _createElementBlock("img", {
                        class: "set-icon",
                        src: _unref(SetsInfos)[v].icon,
                        key: v
                      }, null, 8 /* PROPS */, _hoisted_4))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                })
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_5, "All Cards"))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _renderSlot(_ctx.$slots, "beforeList"),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
        return (_openBlock(), _createElementBlock("div", {
          key: option,
          onPointerup: [
            _withModifiers(($event: any) => (pointerup(option)), ["exact","stop"]),
            _withModifiers(($event: any) => (ctrlpointerup(option)), ["ctrl","exact","stop"])
          ],
          onPointerdown: ($event: any) => (pointerdown($event, option)),
          onPointerout: ($event: any) => (pointerout(option)),
          class: _normalizeClass(["option", {
					'multiselect-selected': __props.modelValue.includes(option),
					ctrl: ctrlPressed.value,
					'long-press': longPressingSet.value === option,
				}])
        }, [
          _renderSlot(_ctx.$slots, "option", { option: option }, () => [
            _createElementVNode("span", _hoisted_8, [
              _createElementVNode("img", {
                class: "set-icon padded-icon",
                src: _unref(SetsInfos)[option].icon,
                alt: _unref(SetsInfos)[option].code,
                height: "16",
                width: "48"
              }, null, 8 /* PROPS */, _hoisted_9),
              _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(SetsInfos)[option].fullName), 1 /* TEXT */)
            ])
          ])
        ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_7))
      }), 128 /* KEYED_FRAGMENT */)),
      _renderSlot(_ctx.$slots, "afterList")
    ])
  ], 34 /* CLASS, NEED_HYDRATION */))
}
}

})